export default __webpack_public_path__ + "static/media/light-violet-activity.726cee2a.svg";